import { render, staticRenderFns } from "./SubSidebarMenu.vue?vue&type=template&id=69789aa5"
import script from "./SubSidebarMenu.vue?vue&type=script&lang=js"
export * from "./SubSidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./SubSidebarMenu.vue?vue&type=style&index=0&id=69789aa5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports